Vue.component('panel-survey', {
	props: ["options", "labellang"],
	template: '<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="bounceOutDown" v-bind:css="options.internal.isAnimationCompatibility">' +
		'<div id="panel-survey" class="panel-widget">' +
		'<div class="overlay-content text-center">' +
		'<h3>{{ title }}</h3>' +
		'<div v-for="(item,index) in listSurvey" @click.once="callLink(item)" class="item">{{ item }}</div>' +
		'</div>' +
		'<div class="overlay-footer">' +
		'<button v-if="btCancelVisible" @click="closeView" class="btn pull-left" > {{ cancel }} </button>' +
		// '<button @click.prevent="sendWidget"   class="btn btn-info pull-right"  data-language="send" >{{ send }}</button>' +
		'</div>' +
		'</div>' +
		'</div>' +
		'</transition>',
	data: function () {
		return {
			isActive: false,
			title: null,
			send: this.labellang.webcb_send_button,
			cancel: this.labellang.cancel,
			btCancelVisible: false,
			listSurvey:[10,9,8,7,6,5,4,3,2,1,0],
			currrentItem:null

		}
	},
	mounted: function () {
		var that = this;
		bus.$on('onShowPanelSurvey', function (val) {
			that.contentShow(val);
		})

	},
	methods: {
		contentShow: function (val) {
			this.isActive = val;
		},
		closeView: function () {
			this.isActive = false;
		},
		callLink: function (item) {
			this.currrentItem = item;
			if(typeof this.currrentItem === "number" && this.isActive ){
				this.currrentItem = this.currrentItem.toString()
			}
			bus.$emit("onCloseWidget", this.currrentItem);
			this.closeView();
		}
	}
})